
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("6BCpV"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("6BCpV", function(module, exports) {

let $4cf3ff9f1a9bdb42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cf3ff9f1a9bdb42$var$load("h3ABO"),
    $4cf3ff9f1a9bdb42$var$load("lTK3c"),
    $4cf3ff9f1a9bdb42$var$load("1WXdc"),
    $4cf3ff9f1a9bdb42$var$load("U4fwL"),
    $4cf3ff9f1a9bdb42$var$load("kaB35"),
    $4cf3ff9f1a9bdb42$var$load("8Fbef"),
    $4cf3ff9f1a9bdb42$var$load("cvmn7"),
    $4cf3ff9f1a9bdb42$var$load("jmFg4"),
    $4cf3ff9f1a9bdb42$var$load("6tWV0"),
    $4cf3ff9f1a9bdb42$var$load("2YffH"),
    $4cf3ff9f1a9bdb42$var$load("6wr18"),
    $4cf3ff9f1a9bdb42$var$load("6mHrv"),
    $4cf3ff9f1a9bdb42$var$load("hdYRX"),
    $4cf3ff9f1a9bdb42$var$load("1YS9Y"),
    $4cf3ff9f1a9bdb42$var$load("6qlX6"),
    $4cf3ff9f1a9bdb42$var$load("c28JM"),
    $4cf3ff9f1a9bdb42$var$load("hZtKG"),
    $4cf3ff9f1a9bdb42$var$load("kCvt5"),
    $4cf3ff9f1a9bdb42$var$load("hyzoX"),
    $4cf3ff9f1a9bdb42$var$load("cmqxT"),
    $4cf3ff9f1a9bdb42$var$load("9anPW"),
    $4cf3ff9f1a9bdb42$var$load("6r6j2"),
    $4cf3ff9f1a9bdb42$var$load("c7Kmx"),
    $4cf3ff9f1a9bdb42$var$load("eBRUf"),
    $4cf3ff9f1a9bdb42$var$load("im1VN"),
    $4cf3ff9f1a9bdb42$var$load("kUoOJ"),
    $4cf3ff9f1a9bdb42$var$load("8Skll"),
    $4cf3ff9f1a9bdb42$var$load("7gHIc"),
    $4cf3ff9f1a9bdb42$var$load("9ijrN"),
    $4cf3ff9f1a9bdb42$var$load("jLOHm"),
    $4cf3ff9f1a9bdb42$var$load("lk5YE"),
    $4cf3ff9f1a9bdb42$var$load("eZnzH"),
    $4cf3ff9f1a9bdb42$var$load("Wowvf"),
    $4cf3ff9f1a9bdb42$var$load("dbdNk"),
    $4cf3ff9f1a9bdb42$var$load("h5FT3"),
    $4cf3ff9f1a9bdb42$var$load("b81Ct"),
    $4cf3ff9f1a9bdb42$var$load("fv7VG"),
    $4cf3ff9f1a9bdb42$var$load("3GuOt"),
    $4cf3ff9f1a9bdb42$var$load("3sb7M"),
    $4cf3ff9f1a9bdb42$var$load("5NQgH"),
    $4cf3ff9f1a9bdb42$var$load("daVOf"),
    $4cf3ff9f1a9bdb42$var$load("k3jER"),
    $4cf3ff9f1a9bdb42$var$load("9ldRJ"),
    $4cf3ff9f1a9bdb42$var$load("9wzNh"),
    $4cf3ff9f1a9bdb42$var$load("hv4mn"),
    $4cf3ff9f1a9bdb42$var$load("37ldp"),
    $4cf3ff9f1a9bdb42$var$load("hhss7"),
    $4cf3ff9f1a9bdb42$var$load("6iz6l"),
    $4cf3ff9f1a9bdb42$var$load("4SCW2"),
    $4cf3ff9f1a9bdb42$var$load("ffEVr"),
    $4cf3ff9f1a9bdb42$var$load("8YSo7"),
    $4cf3ff9f1a9bdb42$var$load("4IGkG"),
    $4cf3ff9f1a9bdb42$var$load("70hqB"),
    $4cf3ff9f1a9bdb42$var$load("f95iu"),
    $4cf3ff9f1a9bdb42$var$load("7k1ns"),
    $4cf3ff9f1a9bdb42$var$load("6bVVs"),
    $4cf3ff9f1a9bdb42$var$load("7mo6o"),
    $4cf3ff9f1a9bdb42$var$load("5GaTI"),
    $4cf3ff9f1a9bdb42$var$load("eTYdV"),
    $4cf3ff9f1a9bdb42$var$load("7EorR"),
    $4cf3ff9f1a9bdb42$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.e51df8fa.js.map
